/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * category of notes:
 *   * WARNING
 *   * ERROR
 *   * INFORMATION
 *   * WEATHER
 */
export enum InformationMessageCategory {
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  INFORMATION = 'INFORMATION',
  WEATHER = 'WEATHER'
}
